"use strict";

const LidEnforcementController = require("./lidEnforcementController");
const BaseEnforcementLetterManagement = require("../../enforcement/baseEnforcementLetterManagement");

const EnforcementLetterManagement = function () {
  const base = BaseEnforcementLetterManagement(LidEnforcementController);

  return {
    ...base,
  };
};

module.exports = EnforcementLetterManagement();
